var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDiscoverIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 125.43 78.39",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#f9f9f9;}.cls-2{fill:#f58220;}.cls-3{fill:url(#radial-gradient);}.cls-4{fill:#001722;}.cls-5{fill:#231f20;}"), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: 57.82,
    cy: -446.88,
    r: 6.18,
    gradientTransform: "translate(6.42 486.08)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#ffeee0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#fee9d7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#fddbbf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#fbc597"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#f8a560"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f48120"
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Asset 1denis") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 125.43,
    height: 78.39,
    rx: 4.18
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M34.48,78.39h86.77a4.18,4.18,0,0,0,4.18-4.18V44.86C117.1,50.14,85.71,68.34,34.48,78.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M64.25,33.09a6.15,6.15,0,0,0-6.26,6,6.25,6.25,0,1,0,6.26-6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M28.71,33.31H25.35V45.05H28.7a6.11,6.11,0,0,0,4.18-1.35A5.92,5.92,0,0,0,35,39.19C35,35.72,32.42,33.31,28.71,33.31Zm2.68,8.82a4.37,4.37,0,0,1-3.14.93h-.61V35.3h.61a4.24,4.24,0,0,1,3.14,1,3.93,3.93,0,0,1,1.26,2.92A4,4,0,0,1,31.39,42.13Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 36.07,
    y: 33.31,
    width: 2.29,
    height: 11.74
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M44,37.81c-1.38-.51-1.78-.84-1.78-1.47s.71-1.3,1.7-1.3a2.39,2.39,0,0,1,1.85.94l1.2-1.56a5.12,5.12,0,0,0-3.45-1.3,3.44,3.44,0,0,0-3.66,3.36c0,1.62.74,2.44,2.88,3.22a8.06,8.06,0,0,1,1.59.67A1.4,1.4,0,0,1,45,41.58a1.67,1.67,0,0,1-1.78,1.65,2.7,2.7,0,0,1-2.5-1.56L39.22,43.1a4.57,4.57,0,0,0,4.07,2.23,3.78,3.78,0,0,0,4-3.85C47.33,39.61,46.56,38.77,44,37.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M48.05,39.19a6.08,6.08,0,0,0,6.2,6.12,6.31,6.31,0,0,0,2.87-.68v-2.7a3.67,3.67,0,0,1-2.77,1.29,3.84,3.84,0,0,1-3.94-4,3.9,3.9,0,0,1,3.84-4,3.84,3.84,0,0,1,2.87,1.32V33.77a5.83,5.83,0,0,0-2.82-.72A6.17,6.17,0,0,0,48.05,39.19Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "75.67 41.2 72.54 33.31 70.04 33.31 75.02 45.35 76.25 45.35 81.32 33.31 78.84 33.31 75.67 41.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "82.36 45.05 88.86 45.05 88.86 43.06 84.65 43.06 84.65 39.89 88.69 39.89 88.69 37.9 84.65 37.9 84.65 35.3 88.86 35.3 88.86 33.31 82.36 33.31 82.36 45.05"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M97.92,36.78c0-2.2-1.52-3.47-4.16-3.47H90.37V45.05h2.29V40.33H93l3.16,4.72h2.82l-3.7-4.95A3.12,3.12,0,0,0,97.92,36.78Zm-4.6,1.93h-.66V35.16h.7c1.43,0,2.2.6,2.2,1.74S94.79,38.71,93.32,38.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M99.53,34.19c0-.21-.14-.32-.39-.32h-.33v1h.24v-.4l.29.4h.31l-.34-.43A.27.27,0,0,0,99.53,34.19Zm-.43.14h0v-.27h0c.12,0,.19,0,.19.13S99.22,34.33,99.1,34.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M99.19,33.48a.91.91,0,1,0,.89.9A.9.9,0,0,0,99.19,33.48Zm0,1.64a.74.74,0,0,1,0-1.48.74.74,0,0,1,0,1.48Z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscoverIcon);
export default __webpack_public_path__ + "static/media/discover-icon.e879d210ecb7c3e2d5207b2041ae071a.svg";
export { ForwardRef as ReactComponent };